import { __extends } from "tslib";
import * as React from 'react';
import Logo from './../../Assets/Images/Logos/Post/post-logo.svg';
import AppHistory from '../../Core/AppHistory';
var PostLogo = /** @class */ (function (_super) {
    __extends(PostLogo, _super);
    /**
     * Class constructor
     * @param {any} props Component props
     */
    function PostLogo(props) {
        return _super.call(this, props) || this;
    }
    /**
     * Get image to display
     * @returns {JSX.Element} Image component
     * */
    PostLogo.prototype.GetImage = function () {
        return React.createElement("img", { className: "post-logo", src: Logo, alt: "Post logo" });
    };
    /**
     * Handle logo click event
     * @returns {boolean} Click result
     * */
    PostLogo.prototype.HandleClick = function (e) {
        e.preventDefault();
        AppHistory.Push("/");
        return false;
    };
    /**
     * Render component
     * @returns {JSX.Element} Component layout
     */
    PostLogo.prototype.render = function () {
        var _this = this;
        return (React.createElement("a", { href: "/", onClick: function (e) { _this.HandleClick(e); } }, this.GetImage()));
    };
    return PostLogo;
}(React.PureComponent));
export { PostLogo };
//# sourceMappingURL=PostLogo.js.map